import Button from '@components/Atoms/Button';
import ShowIf from '@components/Atoms/ShowIf';
import { Badge } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import React from 'react';

interface GenerateQuestionsButtonProps {
  /** The data test id for testing purposes */
  dataTestId?: string;
  setOpen: (open: boolean) => void;
  hasAuthorAideAccess: boolean;
}

const GenerateQuestionsButton: React.FC<GenerateQuestionsButtonProps> = ({
  dataTestId,
  setOpen,
  hasAuthorAideAccess,
}) => (
  <ShowIf If={hasAuthorAideAccess}>
    <Badge
      badgeContent={
        <StarIcon
          sx={{
            color: 'white',
            fontSize: '0.75rem',
          }}
        />
      }
      color="secondary"
    >
      <Button
        dataTestId={dataTestId}
        variant="contained"
        onClick={() => {
          setOpen(true);
        }}
      >
        Generate Questions with CoAuthor
      </Button>
    </Badge>
  </ShowIf>
);

export default GenerateQuestionsButton;
